<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>Activity Guidance</md-icon>
                    </div>
                    <h4 class="title">Edit Activity Guidance</h4>
                </md-card-header>

                <form @submit.prevent="update">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Resource Type
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="activityGuidance.request_type" />
                                    <validation-error :errors="apiValidationErrors.request_type" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Labourer Count
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="activityGuidance.labourer_count" />
                                    <validation-error :errors="apiValidationErrors.labourer_count" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Activity
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="activityGuidance.activity.id" name="activities">
                                        <md-option
                                                v-for="activity in available_activities"
                                                :key="activity.id"
                                                :value="activity.id"
                                        >
                                            {{ activity.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Guidance
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="activityGuidance.guidance.id" name="guidances">
                                        <md-option
                                                v-for="guidance in available_guidances"
                                                :key="guidance.id"
                                                :value="guidance.id"
                                        >
                                            {{ guidance.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Work Place
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="activityGuidance.workplace.id" name="workplaces">
                                        <md-option
                                                v-for="workplace in available_workplaces"
                                                :key="workplace.id"
                                                :value="workplace.id"
                                        >
                                            {{ workplace.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Shift
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="activityGuidance.shift.id" name="shifts">
                                        <md-option
                                                v-for="shift in available_shifts"
                                                :key="shift.id"
                                                :value="shift.id"
                                        >
                                            {{ shift.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Vessel
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="activityGuidance.vessel.id" name="vessels">
                                        <md-option
                                                v-for="vessel in available_vessels"
                                                :key="vessel.id"
                                                :value="vessel.id"
                                        >
                                            {{ vessel.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Activity Tariff
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="activityGuidance.activity_tariff" name="activity_tariffs">
                                        <md-option
                                                v-for="activity_tariff in available_activity_tariffs"
                                                :key="activity_tariff.id"
                                                :value="activity_tariff.id"
                                        >
                                            {{ activity_tariff.amount }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Update Activity Guidance</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>

<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';

export default {
    components: { ValidationError },

    mixins: [formMixin],

    data: () => ({

        activityGuidance: {
            type: 'activityGuidances',
            request_type: null,
            labourer_count: null,
            activity: {
                id: null,
                type: 'activities',
            },
            guidance: {
                id: null,
                type: 'guidances',
            },
            shift:{
                id: null,
                type: 'shifts',
            },
            vessel: {
                id: null,
                type: 'vessels',
            },
            workplace: {
                id: null,
                type: 'workplaces',
            },
            activity_tariff: {
                id: null,
                type: 'activityTariffs',
            },
            relationshipNames: ['activity','guidance','shift','vessel','workplace','activity_tariff'],
        },
        available_activities: [],
        available_guidances: [],
        available_shifts: [],
        available_vessels: [],
        available_workplaces: [],
        available_activity_tariffs: [],

    }),

    created () {
        this.get();
        this.getActivities();
        this.getGuidances();
        this.getShifts();
        this.getVessels();
        this.getWorkplaces();
        this.getActivityTariffs();
    },
    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
                // return service.get(id)
                //     .then((response)=>{
                //         console.log(response);
                //     });
                // console.log(this.$store.dispatch("activities/get", id));
                await this.$store.dispatch('activityGuidances/get', id);
                // console.log(this.$store.getters)
                this.activityGuidance = this.$store.getters['activityGuidances/activityGuidance'];
                // console.log(this.guidance);
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },

        async update () {
            if (
                this.$isDemo == 1 &&
                    ['1', '2', '3'].includes(this.$route.params.id)
            ) {
                await this.$store.dispatch(
                    'alerts/error',
                    'You are not allowed to change data of default roles.'
                );
                return;
            }
            try {
                await this.$store.dispatch('activityGuidances/update', this.activityGuidance);
                await this.$store.dispatch(
                    'alerts/success',
                    'A tivity Guidance updated successfully.'
                );
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].detail
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },
        getActivities () {
            this.$store.dispatch('activities/list').then(() => {
                console.log(this.$store);
                this.available_activities = this.$store.getters['activities/list'];
            });
        },
        getGuidances () {
            this.$store.dispatch('guidances/list').then(() => {
                this.available_guidances = this.$store.getters['guidances/list'];
            });
        },
        getShifts () {
            this.$store.dispatch('shifts/list').then(() => {
                this.available_shifts = this.$store.getters['shifts/dropdown'];
            });
        },
        getVessels () {
            this.$store.dispatch('vessels/list').then(() => {
                this.available_vessels = this.$store.getters['vessels/dropdown'];
            });
        },
        getWorkplaces () {
            this.$store.dispatch('workplaces/list').then(() => {
                this.available_workplaces = this.$store.getters['workplaces/list'];
            });
        },
        getActivityTariffs () {
            this.$store.dispatch('activityTariffs/list').then(() => {
                this.available_activity_tariffs = this.$store.getters['activityTariffs/dropdown'];
            });
        },

        goBack () {
            this.$router.push({ name: 'Activity Guidances List' });
        },
    },
};
</script>
